import(/* webpackMode: "eager" */ "/vercel/path0/apps/capeX/src/app/loading.tsx");
